import { cn } from '@skrym/shared/utils/cn';

export type TailwindColor =
  | 'transparent'
  | 'current'
  | 'black'
  | 'white'
  | 'gray'
  | 'red'
  | 'yellow'
  | 'green'
  | 'blue'
  | 'indigo'
  | 'purple'
  | 'pink'
  | 'rose'
  | 'amber'
  | 'lime'
  | 'emerald'
  | 'teal'
  | 'cyan'
  | 'sky'
  | 'violet'
  | 'fuchsia'
  | 'coolGray'
  | 'trueGray'
  | 'warmGray'
  | 'orange'
  | 'lightBlue'
  | 'darkBlue';

export const tailwindColorClasses: Record<TailwindColor, string> = {
  transparent: 'bg-transparent dark:bg-transparent/20 text-black dark:text-white',
  current: 'bg-current dark:bg-current/20 text-current dark:text-current',
  black: 'bg-black dark:bg-black/20 text-black dark:text-white',
  white: 'bg-white dark:bg-white/20 text-white dark:text-black',
  gray: 'bg-gray-200 dark:bg-gray-700/20 text-gray-800 dark:text-gray-500',
  red: 'bg-red-200 dark:bg-red-700/20 text-red-800 dark:text-red-500',
  yellow: 'bg-yellow-200 dark:bg-yellow-700/20 text-yellow-800 dark:text-yellow-500',
  green: 'bg-green-200 dark:bg-green-700/20 text-green-800 dark:text-green-500',
  blue: 'bg-blue-200 dark:bg-blue-700/20 text-blue-800 dark:text-blue-500',
  indigo: 'bg-indigo-200 dark:bg-indigo-700/20 text-indigo-800 dark:text-indigo-500',
  purple: 'bg-purple-200 dark:bg-purple-700/20 text-purple-800 dark:text-purple-500',
  pink: 'bg-pink-200 dark:bg-pink-700/20 text-pink-800 dark:text-pink-500',
  rose: 'bg-rose-200 dark:bg-rose-700/20 text-rose-800 dark:text-rose-500',
  amber: 'bg-amber-200 dark:bg-amber-700/20 text-amber-800 dark:text-amber-500',
  lime: 'bg-lime-200 dark:bg-lime-700/20 text-lime-800 dark:text-lime-500',
  emerald: 'bg-emerald-200 dark:bg-emerald-700/20 text-emerald-800 dark:text-emerald-500',
  teal: 'bg-teal-200 dark:bg-teal-700/20 text-teal-800 dark:text-teal-500',
  cyan: 'bg-cyan-200 dark:bg-cyan-700/20 text-cyan-800 dark:text-cyan-500',
  sky: 'bg-sky-200 dark:bg-sky-700/20 text-sky-800 dark:text-sky-500',
  violet: 'bg-violet-200 dark:bg-violet-700/20 text-violet-800 dark:text-violet-500',
  fuchsia: 'bg-fuchsia-200 dark:bg-fuchsia-700/20 text-fuchsia-800 dark:text-fuchsia-500',
  coolGray: 'bg-coolGray-200 dark:bg-coolGray-700/20 text-coolGray-800 dark:text-coolGray-500',
  trueGray: 'bg-trueGray-200 dark:bg-trueGray-700/20 text-trueGray-800 dark:text-trueGray-500',
  warmGray: 'bg-warmGray-200 dark:bg-warmGray-700/20 text-warmGray-800 dark:text-warmGray-500',
  orange: 'bg-orange-200 dark:bg-orange-700/20 text-orange-800 dark:text-orange-500',
  lightBlue: 'bg-lightBlue-200 dark:bg-lightBlue-700/20 text-lightBlue-800 dark:text-lightBlue-500',
  darkBlue: 'bg-darkBlue-200 dark:bg-darkBlue-700/20 text-darkBlue-800 dark:text-darkBlue-500',
};

export const tailwindColorHoverClasses: Record<TailwindColor, string> = {
  transparent:
    'transition-all ease-in-out delay-50 hover:bg-transparent-300 dark:hover:bg-transparent-900 hover:text-transparent-900 dark:hover:text-transparent-300',
  current:
    'transition-all ease-in-out delay-50 hover:bg-current-300 dark:hover:bg-current-900 hover:text-current-900 dark:hover:text-current-300',
  black:
    'transition-all ease-in-out delay-50 hover:bg-black-300 dark:hover:bg-black-900 hover:text-black-900 dark:hover:text-black-300',
  white:
    'transition-all ease-in-out delay-50 hover:bg-white-300 dark:hover:bg-white-900 hover:text-white-900 dark:hover:text-white-300',
  gray: 'transition-all ease-in-out delay-50 hover:bg-gray-300 dark:hover:bg-gray-900 hover:text-gray-900 dark:hover:text-gray-300',
  red: 'transition-all ease-in-out delay-50 hover:bg-red-300 dark:hover:bg-red-900 hover:text-red-900 dark:hover:text-red-300',
  yellow:
    'transition-all ease-in-out delay-50 hover:bg-yellow-300 dark:hover:bg-yellow-900 hover:text-yellow-900 dark:hover:text-yellow-300',
  green:
    'transition-all ease-in-out delay-50 hover:bg-green-300 dark:hover:bg-green-900 hover:text-green-900 dark:hover:text-green-300',
  blue: 'transition-all ease-in-out delay-50 hover:bg-blue-300 dark:hover:bg-blue-900 hover:text-blue-900 dark:hover:text-blue-300',
  indigo:
    'transition-all ease-in-out delay-50 hover:bg-indigo-300 dark:hover:bg-indigo-900 hover:text-indigo-900 dark:hover:text-indigo-300',
  purple:
    'transition-all ease-in-out delay-50 hover:bg-purple-300 dark:hover:bg-purple-900 hover:text-purple-900 dark:hover:text-purple-300',
  pink: 'transition-all ease-in-out delay-50 hover:bg-pink-300 dark:hover:bg-pink-900 hover:text-pink-900 dark:hover:text-pink-300',
  rose: 'transition-all ease-in-out delay-50 hover:bg-rose-300 dark:hover:bg-rose-900 hover:text-rose-900 dark:hover:text-rose-300',
  amber:
    'transition-all ease-in-out delay-50 hover:bg-amber-300 dark:hover:bg-amber-900 hover:text-amber-900 dark:hover:text-amber-300',
  lime: 'transition-all ease-in-out delay-50 hover:bg-lime-300 dark:hover:bg-lime-900 hover:text-lime-900 dark:hover:text-lime-300',
  emerald:
    'transition-all ease-in-out delay-50 hover:bg-emerald-300 dark:hover:bg-emerald-900 hover:text-emerald-900 dark:hover:text-emerald-300',
  teal: 'transition-all ease-in-out delay-50 hover:bg-teal-300 dark:hover:bg-teal-900 hover:text-teal-900 dark:hover:text-teal-300',
  cyan: 'transition-all ease-in-out delay-50 hover:bg-cyan-300 dark:hover:bg-cyan-900 hover:text-cyan-900 dark:hover:text-cyan-300',
  sky: 'transition-all ease-in-out delay-50 hover:bg-sky-300 dark:hover:bg-sky-900 hover:text-sky-900 dark:hover:text-sky-300',
  violet:
    'transition-all ease-in-out delay-50 hover:bg-violet-300 dark:hover:bg-violet-900 hover:text-violet-900 dark:hover:text-violet-300',
  fuchsia:
    'transition-all ease-in-out delay-50 hover:bg-fuchsia-300 dark:hover:bg-fuchsia-900 hover:text-fuchsia-900 dark:hover:text-fuchsia-300',
  coolGray:
    'transition-all ease-in-out delay-50 hover:bg-coolGray-300 dark:hover:bg-coolGray-900 hover:text-coolGray-900 dark:hover:text-coolGray-300',
  trueGray:
    'transition-all ease-in-out delay-50 hover:bg-trueGray-300 dark:hover:bg-trueGray-900 hover:text-trueGray-900 dark:hover:text-trueGray-300',
  warmGray:
    'transition-all ease-in-out delay-50 hover:bg-warmGray-300 dark:hover:bg-warmGray-900 hover:text-warmGray-900 dark:hover:text-warmGray-300',
  orange:
    'transition-all ease-in-out delay-50 hover:bg-orange-300 dark:hover:bg-orange-900 hover:text-orange-900 dark:hover:text-orange-300',
  lightBlue:
    'transition-all ease-in-out delay-50 hover:bg-lightBlue-300 dark:hover:bg-lightBlue-900 hover:text-lightBlue-900 dark:hover:text-lightBlue-300',
  darkBlue:
    'transition-all ease-in-out delay-50 hover:bg-darkBlue-300 dark:hover:bg-darkBlue-900 hover:text-darkBlue-900 dark:hover:text-darkBlue-300',
};

export interface ChipProps {
  color: TailwindColor;
  dashed?: boolean;
  label: string;
  /**
    @deprecated Caused a large bundle increase
  */
  icon?: string;
  textSize?: string; // optional override of the tailwind font size
}

function Chip(props: ChipProps) {
  const { color, dashed, label } = props;

  return (
    <div
      className={cn(
        'inline-flex items-center px-1.5 py-0.5 gap-1 rounded-full font-medium overflow-hidden text-ellipsis text-center',
        dashed
          ? 'border-gray-400 dark:border-gray-700 border border-dashed text-neutral-500'
          : tailwindColorClasses[color],
        props.textSize || 'text-xs',
      )}
    >
      {label}
    </div>
  );
}

export default Chip;
